import React, { Component } from 'react';
import { FileExportOptions } from 'Common/Constants/Enumeration/FileExportOptions';
import { Field } from 'redux-form';
import { SelectField } from 'Common/SemanticWrapper';
import { ExportTypeDropdownName } from 'Common/Constants/exportTypeDropdownName';

export class ExportTypeDropdown extends Component {
  render() {
    return (
      <Field
        name={ExportTypeDropdownName}
        component={SelectField}
        {...this.props}
        options={FileExportOptions}
        label={'Export Type'}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/ExportTypeDropdown.js